(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9915],{

/***/ 62222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/vinted-wallet/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-02-22",
      tag: "Vinted",
      title: "Top Things to Know about Vinted Wallet",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you're a new Vinted seller or on the fence about selling on this platform, you might be relieved to know that its payment system works similar to other online marketplaces."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "It has Vinted Wallet, where all earnings from your sold listings are stored. You can transfer your payout to your linked bank account or use the credits to buy items from other Vinted sellers from this Wallet."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Here we'll work you through the entire process, from setting up your Wallet to dealing with common payout problems."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to set up and activate our Vinted Wallet"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Prepare for your first sale and payout by ensuring you have already entered your bank details. Simply tap your profile icon and locate \"Payments\" under \"Settings.\" Within \"Payout options,\" add your bank account, provide the requested information, and hit save within \"Payout options."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Go back to your profile icon and locate \"Wallet\" this time. You will then see the option to activate your Wallet. Do it right away, or at least within five days of making your first sale. Because if not, Vinted might have to cancel the order."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Sometimes, Vinted's payment partner Adyen would request additional steps to verify the account user's identity. This may happen early on when setting up the Wallet (e.g., the user entered bank details already existing in their system, as previously provided by another user) or anytime during the seller's journey (e.g., when the user exceeded the sale limits.)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Providing a valid ID, and in some instances, a bank statement or a proof of billing address, is enough to pass the identity check and clear the air. Incompliance may result in immediate and permanent account blocking to protect the Vinted community from any possible fraudulent or malicious activities."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How sellers get paid"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Every time a buyer checks out an item of yours for payment, the amount will appear in your Vinted Wallet as a pending balance. This is a standard procedure among all sale transactions \u2013 within Vinted and other reselling platforms \u2013 to ensure that buyers get what they paid for before the sellers access the money from the sold items. The money for the refund will also be taken out on this balance when a dispute is filed against the seller, and they are proven to be at fault.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The amount will then appear as an available balance upon confirmation of delivery or order completion. The buyer can do this by tapping \"Everything's OK,\" or it will happen automatically two days after delivery if the buyer raises no issue during the hold period."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["The available balance can stay in your Vinted Wallet for as long as you want until you decide to purchase any item from within the platform or direct your earnings to your registered bank account.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When doing a payout to your bank, it wouldn't hurt to double-check the saved bank details to make sure you're transferring to the right account. It is also advisable to do the transfer only if you're in a place with a reliable internet connection, as you'll never know when a spotty connection could lead to technical errors and hassles."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If your payout is successful, expect to see your transferred funds in your bank account within a few days to as long as two weeks, depending on how easily your bank recognizes the payout as coming from your Vinted account."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What to do when the payout fails to reach your bank account"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "A payout can get rejected if your account is in trouble. Perhaps you have not passed the identity verification step mentioned earlier or have not settled a technical issue. It is best to contact Vinted directly to inquire about the matter and fix it immediately. Another reason for the payout failure is insufficient funds. Make sure you are transferring an amount that can be readily be covered by your available balance because the pending balance doesn't count yet."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Again, it's important to be certain that you have entered the correct bank information. Vinted will not be able to help you out once you're confirmed the transfer to your bank account; You'd have to get in touch with your bank as soon as you realize the mistake. Provide them with the date and amount of the payout for easier tracking.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Receiving payments and processing payouts should be easy in Vinted, especially if you already have experience selling on other marketplaces. We hope everything goes well in your first \u2013 and every \u2013 sale and payout!"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/vinted-wallet.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Top Things to Know about Vinted Wallet"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Learn how you can use your Vinted Wallet as a seller, why your balance is pending, and what to do when a payout fails."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/vinted-wallet"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/vinted-wallet"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Top Things to Know about Vinted Wallet"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Learn how you can use your Vinted Wallet as a seller, why your balance is pending, and what to do when a payout fails."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "February 22nd, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "February 22nd, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Vinted"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 15250:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/vinted-wallet",
      function () {
        return __webpack_require__(62222);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(15250); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);